import { Component, OnInit,ViewChild,Pipe,PipeTransform} from '@angular/core';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { LoginService } from '../Shared/Service/login_service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { interval } from 'rxjs';
import { ExcelServicesService } from '../Shared/Service/excel-services';
export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "LL",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
export class idsProductList {
  id: number;
  pmscode: String;
}
@Component({
  selector: 'app-taj-inner-circle',
  templateUrl: './taj-inner-circle.component.html',
  styleUrls: ['./taj-inner-circle.component.css'],
  providers: [
      LoginService,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class TajInnerCircleComponent implements OnInit {
  displayedColumns: string[] = [ 'shortname' ,'accountingdate',  'createdatetime' , 'validationtime' , 'pushedtime', 'filepath', 'transfertype', 'status'  ];
    Userid: any = [];
    apiresult: any;
    hotellistproperty: any;
    dropdownDeptData: any
    isProgressing: Boolean = false;
    dropdownSettingsDept: IDropdownSettings = {};
    searchBarFilter: boolean = false;
    selectedDate: any = new Date();
    selectedTOODate: any = new Date();
    public PGF: any = 0;
    public PGT: any = 50;
    pageSize = 50;
    requestPayload: any;
    public Pmscodevalue: any;
    selectedDeptItems: any;
    searchText = "";
    errorMessage: string;
    errorMsgSubscription: boolean;
    displayContent: boolean;
    addBtnDisabledFunc: boolean = true;
    hotelSearchDataStatus: any;
    heartBeatData: any;
    productType: any;
    currentDateStore: any;
    storeHeartBeatValue: any;
    blinkOfflineHotel: boolean;
    filterProperty: any
    excelFunction: boolean = false;
    dataSource: MatTableDataSource<idsProductList>
    StorelstRestr: any;
    totalcount: any = 0;
    idsProductList: idsProductList[] = [];
    //Indhuja 18-05-2025 Start
    statusResult: string;
    SourceBy: string= 'Report'; 
    storeOptionData = "LOG";
    //Indhuja 18-05-2025 End
      //Indhuja 09-04-2025 Start
  selectedRe_ProcessDate: Date = new Date();         // From Date default to today
  selectedReProcessToDate: Date = new Date();       // To Date default to today
  maxReprocessDate: Date = new Date();
//Indhuja 09-04-2025 End
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    today = new Date();

  constructor(private excelService: ExcelServicesService,private apiCallIdsService: DashboarduiService,private toastr: ToastrService,private datePipe: DatePipe) { }

  ngOnInit() {
    this.isProgressing = true;
     this.statusResult = "Not Sent" //Indhuja 18-05-2025 
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.gettajInnerCirclepropertylist()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          this.apiresult = data;
          this.hotellistproperty = this.apiresult;
          this.dropdownDeptData = this.apiresult;
          console.log('Property 113 = ', data)
          this.isProgressing = false;
        });
  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
      this.searchText = '';
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.Pmscodevalue = this.selectedDeptItems[0].pmscode
        console.log('pms code value = ', this.Pmscodevalue)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.addBtnDisabledFunc = false
        // For Online Status
        this.apiCallIdsService
          .readHotelSearch(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHotelSearch =', data)
            this.hotelSearchDataStatus = data[0].recordstatus
            this.productType = data[0].producttype
          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat

            // For blinking the record
            const today = new Date()
            console.log('Today Date = ', today);
            this.currentDateStore = today.toLocaleTimeString('it-IT')
            console.log('Today Date = ', this.currentDateStore);
            this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
            var start = this.storeHeartBeatValue.split(":");
            var end = this.currentDateStore.split(":");
            var startDate = new Date(0, 0, 0, start[0], start[1], 0);
            var endDate = new Date(0, 0, 0, end[0], end[1], 0);
            var diff = endDate.getTime() - startDate.getTime();
            var hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            var minutes = Math.floor(diff / 1000 / 60);
            // console.log('minutes difference',minutes)
            console.log('minutes difference', hours + ":" + minutes)
            if ((hours + ":" + minutes) > "0:30") {
              console.log('blinkOfflineHotel true')
              this.blinkOfflineHotel = true
            } else {
              console.log('blinkOfflineHotel false')
              this.blinkOfflineHotel = false
            }
          });
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
        });
      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.addBtnDisabledFunc = true
        this.excelFunction = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  heartbeatFunction() {
    this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =', data[0])
        this.heartBeatData = data[0].heartBeat
      });
  }
  GetParseonlyDateTime(d: any) {
    console.log('GetParseonlyDateTime call', d.substring(12))
    return (d.substring(12));
  }
GetTICLOG() {
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');

    }
    if ((this.Pmscodevalue == 0 || this.Pmscodevalue == "undefined" || this.Pmscodevalue == "All Property" || this.Pmscodevalue == "") && (this.selectedTOODate >= this.selectedDate)) {
      this.isProgressing = true;
      this.Pmscodevalue = '0';
      this.Userid = localStorage.getItem("Username");

      this.loadMethodForTICLog();
    }
    else if (this.selectedTOODate >= this.selectedDate) {
      this.isProgressing = true;
      this.Userid = "undefined";
      this.loadMethodForTICLog();
    }
  }
  loadMethodForTICLog() {
    this.searchBarFilter = false
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    }
    else {
      this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
      this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
      this.isProgressing = true;
      // this.PGF = 0;
      // this.PGT = 50;
      console.log('pageSize == ',this.pageSize)
      console.log('PGF == ',this.PGF)
      console.log('PGT == ',this.PGT)
      console.log('selectedDate == ',this.selectedDate)
      console.log('selectedTOODate == ',this.selectedTOODate)
     /*  this.requestPayload = {
        "PMSCODE": this.Pmscodevalue,
        "FRMDATE": this.selectedDate,
        "TOODATE": this.selectedTOODate
      } */
      console.log("this.requestPayload ==", this.requestPayload)
      this.apiCallIdsService.readtajInnerCirclelist(this.Pmscodevalue,this.selectedDate,this.selectedTOODate,this.statusResult)
        .subscribe((res) => {
          this.StorelstRestr = res;
          if (this.StorelstRestr[0].totalCount < 1) {
            this.toastr.error('No Data Found');
            this.totalcount = this.StorelstRestr[0].totalCount;
            console.log(this.totalcount)
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.displayContent = false
            this.excelFunction = false
            this.isProgressing = false;

          } else {
            this.idsProductList = res;
            console.log('response ==',this.StorelstRestr)
            this.totalcount = this.StorelstRestr[0].totalCount;
            console.log('totalcount ==',this.totalcount)
            this.errorMsgSubscription = false
            this.displayContent = true
            this.excelFunction = true
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          }
        });
    }
    
  }

  pageEvent(e: any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.loadMethodForTICLog();
  }
  getFilePaths(filepath: string): string[] { return filepath ? filepath.split(';') : []; }
changeOption(data: any) {
    console.log("changeOption Value--->" + data);
    this.storeOptionData = data
    if (data == 'Re-process') {
      this.statusResult = ""
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    } else {
      this.statusResult = "Not Sent"
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    }
  }
  GetTICLOGPROCESS() {
    const fromDateFormatted = this.datePipe.transform(this.selectedRe_ProcessDate, 'yyyyMMdd');
    const toDateFormatted = this.datePipe.transform(this.selectedReProcessToDate, 'yyyyMMdd');
    console.log("reprocessPmscode",this.Pmscodevalue)
    console.log("From Date:", fromDateFormatted);
    console.log("To Date:", toDateFormatted);
    this.apiCallIdsService.reprocesstajInnerCircle(this.Pmscodevalue,fromDateFormatted,toDateFormatted )
      .subscribe(
        data => {
          console.log('Process Data =',data[0].statusDescription)
          if(data[0].statusDescription == 'Successfully Updated' || data[0].statusDescription == 'Successfully Inserted'){
            this.toastr.success(data[0].statusDescription);
          }else{
            this.toastr.error(data[0].statusDescription);
          }
          this.isProgressing = false;
        });
  }
   onReprocessDateChange(event: any) {
    const selectedDate = new Date(event.value);
    this.selectedRe_ProcessDate = selectedDate;
  
    // Add 30 days from selected date for max allowed to-date
    const newMaxDate = new Date(selectedDate);
    newMaxDate.setDate(newMaxDate.getDate() + 30);
    this.maxReprocessDate = newMaxDate;
  
    // If selected To Date is beyond max, clear it
    if (this.selectedReProcessToDate && this.selectedReProcessToDate > this.maxReprocessDate) {
      this.selectedReProcessToDate = null;
    }
  
    // ❗ Check if From Date is greater than To Date
    if (this.selectedReProcessToDate && selectedDate > this.selectedReProcessToDate) {
      this.toastr.error('To Date should be greater than or equal to From Date') 
        
      this.selectedReProcessToDate = null;
    }
  }
}
